import { Component, OnInit, Input } from '@angular/core';
import { NodoEntity, ServicioFormatoAsistencialService, FiltrosFormatoAsistencialEntity } from '../../../../services/servicio-formato-asistencial.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-cie10',
  templateUrl: './cie10.component.html',
  styleUrls: ['./cie10.component.css']
})
export class Cie10Component implements OnInit {

  @Input() filtros: FiltrosFormatoAsistencialEntity;
  @Input() nodo: NodoEntity;

  titulo: string;
  loading: boolean;
  control: ControlDiagnostico;

  constructor( private servicioFormato: ServicioFormatoAsistencialService) { }

  ngOnInit() {
    if (this.nodo && this.filtros) {
      this.onProcess();
    } else {
      this.titulo = '';
      this.control = null;
    }
  }

  onProcess() {
    this.titulo = this.nodo.titulo;
    this.getControl(this.filtros.codigoBaseDatos, this.filtros.tta);
  }

  async getControl(db: string, tta: number) {
    try {
      this.loading = true;
      const response = await this.servicioFormato.getControlDiagnosticoAsistencial(db, tta);
      if (response != null ) {
        response.subscribe((data: ControlDiagnostico) => {
          this.control = data;
          this.loading = false;
        }, (err: HttpErrorResponse) => {
          this.control = {};
          this.loading = false;
          console.error('Error Control Diagnostico', err);
        });
      }
    } catch (e) {
      this.control = {};
      console.error('Catch Control Diagnostico', e);
    }
  }

  getValue(pos: number): string {
    switch (pos) {
      case 1: {
        return this.control && this.control.diagnosticoPrincipal ?
        `(${this.control.diagnosticoPrincipal.codigoDiagnostico}) ${this.control.diagnosticoPrincipal.descripcion}` : 'sin seleccionar diagnostico';
      }

      case 2: {
        return this.control && this.control.diagnosticoRelacionado1 ?
        `(${this.control.diagnosticoRelacionado1.codigoDiagnostico}) ${this.control.diagnosticoRelacionado1.descripcion}` : 'sin seleccionar diagnostico';
      }

      case 3: {
        return this.control && this.control.diagnosticoRelacionado2 ?
        `(${this.control.diagnosticoRelacionado2.codigoDiagnostico}) ${this.control.diagnosticoRelacionado2.descripcion}` : 'sin seleccionar diagnostico';
      }

      case 4: {
        return this.control && this.control.tipoDiagnostico ? this.getTipoDiagnostico(this.control.tipoDiagnostico) : '--';
      }

      case 5: {
        return this.control && this.control.finalidadConsulta ? this.control.finalidadConsulta : '--';
      }

      case 6: {
        return this.control && this.control.causaConsulta ? this.control.causaConsulta : '--';
      }

      default: return '--';
    }
  }

  getTipoDiagnostico(value: number): string {
    switch (value) {
      case 1: return 'impresión diagnostica';
      case 2: return 'diagnostico nuevo';
      case 3: return 'diagnostico repetido';
      default: return '--';
    }
  }

}

interface ControlDiagnostico {
  diagnosticoPrincipal?: Diagnostico;
  diagnosticoRelacionado1?: Diagnostico;
  diagnosticoRelacionado2?: Diagnostico;
  tipoDiagnostico?: number;
  finalidadConsulta?: string;
  causaConsulta?: string;
}

interface Diagnostico {
  codigoDiagnostico: string;
  descripcion: string;
}
